

















































































interface FormPropsType {
  homepageName: string;
  homepageDescribe: string;
  screenSize: string;
  deviceTags: Array<any>;
  id?: string;
}

interface FormPropsRulesType {
  homepageName: Array<any>;
  homepageDescribe: Array<any>;
  screenSize: Array<any>;
  // deviceTags: Array<any>;
}

import {
  Component,
  Emit,
  Prop,
  Provide,
  Ref,
  Vue,
} from 'vue-property-decorator';

import {ElForm} from 'element-ui/types/form';
import {
  createApp,
  editApp
} from '@/service/project-management/ui-configuration';
import {Getter} from 'vuex-class';
import XRemoteSelect from '@/components/x-components/x-remote-select';
import {ScreenSizeSource} from '@/views/ProjectManagement/UIConfiguration/pages/type';
import { objectAssign } from '@/util';

const FormProps: FormPropsType = {
  homepageName: '',
  homepageDescribe: '',
  screenSize: '',
  deviceTags: [],
  id: '',
};

@Component
export default class OperateDialog extends Vue {

  //@Ref
  @Ref() readonly formEl!: ElForm;
  @Ref() readonly deviceTagSelect!: XRemoteSelect;

  @Getter('pm/projectID')
  readonly projectID!: string;

  dialogVisible: boolean = false;
  dialogLoading: boolean = false;

  formProps: FormPropsType = JSON.parse(JSON.stringify(FormProps));

  rules: FormPropsRulesType = {
    homepageName: [
      {required: true, message: '请输入应用名称', trigger: 'change'},
    ],
    homepageDescribe: [
      {required: true, message: '请输入应用描述', trigger: 'change'},
    ],
    screenSize: [
      {required: true, message: '请选择屏幕尺寸', trigger: 'change'},
    ],
    // deviceTags: [
    //   { required: true, message: "请选择绑定标签", trigger: "change" },
    // ],
  };

  //屏幕尺寸
  ScreenSizeSource: Array<any> = ScreenSizeSource;

  get remoteExtraParams() {
    return {
      projectId: this.projectID,
    };
  }

  open(data?: FormPropsType) {
    if(data){
      objectAssign(_.cloneDeep(data), this.formProps);
    }else{
      this.$set(this,'formProps', JSON.parse(JSON.stringify(FormProps)));
    }
    this.dialogVisible = true;
  }

  close() {
    this.dialogVisible = false;
  }

  handleSubmit() {
    console.log(this.deviceTagSelect)
    this.formEl.validate((valid) => {
      if (valid) {
        const params: any = {
          ...this.formProps,
          projectId: this.projectID,
          deviceTags: this.deviceTagSelect.selections.filter(item => {
            return this.formProps.deviceTags.includes(item.id);
          })
        };
        debugger
        const func = this.formProps.id ? editApp : createApp;
        func(params).then(res => {
          this.$message.success( `${this.formProps.id ? '编辑' : '新增'}成功`);
          this.dialogVisible = false;
          //编辑不需要跳转详情页，新增需要跳转详情页
          this.$emit('submitSuccess',this.formProps.id?null:res.data.homepageDetail);
        });
      }
    });
  }

  handleCancel() {
    this.dialogVisible = false;
  }
}
